import {FilteringGridWithBulkOperations} from './filtering_grid_with_bulk_operations.js';

export const EmbedLibraryView = Backbone.View.extend({
  el: '#embed-library',
  initialize: function() {
    this.editable = this.options.editable
    this.data = this.options.data
    this.clubId = this.options.clubId
    this.userDateFormat = this.options.userDateFormat;
    this.settings = this.options.settings || { }
    this.savedSettings = this.settings.saved || { }

    this.initGrid()

    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
    this.resizeGrid();
    this.resizeGrid();

    $(window).resize(_.debounce(() => {
      this.resizeGrid();
    }, 100));
  },
  events: {
    // bulk operations
    'click .show_bulk_op': 'showBulkOp',
    'click .batch_delete': 'batchDelete',
    // misc
    'click .grid_height_increase': 'increaseGridHeight',
    'click .grid_height_decrease': 'decreaseGridHeight'
  },

  initGrid: function() {
    const data = this.data
    const formatters = FilteringGridWithBulkOperations.formatters

    // column definitions
    const columns = [
      {id: "name", name: 'Name', field: "name", sortable: true},
      {id: "date_created", name: 'Date Created', field: "date_created", sortable: true, formatter: formatters.date.bind(this)},
      {id: "route_tag", name: 'Route Tag', field: "route_tag", sortable: true},
      {id: "poi_tags", name: 'POI Tags', field: "poi_tags", sortable: true, formatter: formatters.genericArray}
    ]

    const columnWidths = Object.assign({
      icon: 10,
      edit: 10
    }, this.savedSettings.columnWidths || {})
    columns.forEach(column => column.width = columnWidths[column.id])

    this.grid = new FilteringGridWithBulkOperations(data, {
      target: '#embed_table',
      columns: columns,
      editable: this.editable,
      editPath: (object) => `/embeds/configure_regional?id=${object.id}`,
      ignoreCaseOnSort: ['name', 'route_tag', 'poi_tags'],
      settingsOpts: this.settings.opts
    });

    this.grid.enableBulkOperations({
      bulkDeletePath: `/route_set_overviews/batch_destroy.json`,
      idsParam: 'embed_ids'
    });

    if (this.savedSettings.sortCol) {
      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc)
    }

    const self = this
    this.grid.slickGrid.onSelectedRowsChanged.subscribe(() => self.updateBulkOpVisibility())
    this.grid.dataView.onRowsChanged.subscribe(() => self.updateBulkOpVisibility())
    self.updateBulkOpVisibility()

  },

  /*
   * bulk operations
   */

  showBulkOp: function(e) {
    const bulkOp = $(e.currentTarget).attr('data-bulk-op');
    const show = !this.$('.bulk_op_' + bulkOp).is(':visible');
    this.$('.bulk_op').hide();
    if(show)
      this.$('.bulk_op_' + bulkOp).show();
    return false;
  },

  batchDelete: function() {
    const items = this.grid.selectedItems
    if (!items.length) {
      return // User message is set in updateBulkOpVisibility
    } else {
      const message = `Are you sure? This will delete ${items.length} selected Embed${items.length > 1 ? 's' : ''}`
      customConfirm(message, () => this.grid.deleteSelectedItems())
    }
    return false
  },

  updateBulkOpVisibility: function() {
    const grid = this.grid.slickGrid
    const data = grid.getData()
    const items = grid.getSelectedRows().map(i => data.getItem(i))

    const noneSelected = items.length == 0 ? "To perform that action, please select at least one embed." : null

    const shouldDisable = {delete: noneSelected}

    this.$("[data-bulk-op]").each((idx, el) => {
      const elem = $(el)
      const op = elem.data("bulk-op")
      const disableMessage = shouldDisable[op]

      if (disableMessage) {
        elem.addClass("bulk-op-disabled")
        elem.attr("data-disabled", disableMessage)
      } else {
        elem.removeClass("bulk-op-disabled")
        elem.removeAttr("data-disabled")
      }
    })

    this.$('.bulk_op').hide();
  },

  showDisabledMessage: function(e) {
    const message = $(e.currentTarget).data('disabled')
    $("#disabled-op-content").html(message)
    $("#disabled-op").modal("show")

    e.stopImmediatePropagation()
  },

  /*
   * misc
   */

  resizeGrid: function() {
    // Don't resize anything if sizes have been set by the user
    if (this.savedSettings.columnWidths) { return }

    this.grid.slickGrid.resizeCanvas();
    this.grid.slickGrid.autosizeColumns();
  },

  increaseGridHeight: function() {
    this.changeGridHeight(100);
  },
  decreaseGridHeight: function() {
    this.changeGridHeight(-100);
  },
  changeGridHeight(amount) {
    const $table = $('#embed_table');
    let height = $table.height();
    if(height + amount < 100) return;
    height += amount;
    $table.height(height).trigger('resize');
    Application.setPreference("embed_library_grid_height", height, true);
  }
});



// WEBPACK FOOTER //
// ./public/javascripts/clubs/embed_library_view.js